/**
 * Historia 176 — CU3 (S89-S96, S155-S156). Pure search/filter logic, no i18n, no JSX (RN6b-RN6f,
 * DG2-0): the caller passes plain strings/keys, never reaches into `i18n` or the artifact itself.
 */

/** Strips diacritics and lowercases, so "Código"/"codigo"/"CÓDIGO" all normalize the same (RN6b). */
const normalize = (text) => String(text).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

/**
 * RN6b: "contains", case- and diacritic-insensitive, over any of the given candidate texts (the
 * standard term, the inherited term, the custom term). An empty or whitespace-only query matches
 * everything (RN6b, S90).
 *
 * @param {string} query What the user typed
 * @param {string[]} candidates The texts of the row to search over
 * @returns {boolean}
 */
export const matchesSearch = (query, candidates) => {
  const normalizedQuery = normalize(query).trim()
  if (normalizedQuery === '') return true
  return candidates.some((candidate) => normalize(candidate).includes(normalizedQuery))
}
